// extracted by mini-css-extract-plugin
var _1 = "CelsiusQuizAppStyle-module__celsius-quiz-app___XWele";
var _2 = "CelsiusQuizAppStyle-module__celsius-quiz-app___XWele";
export { _1 as "celsius-quiz-app", _2 as "celsiusQuizApp" }
